var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrophone = function SvgMicrophone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.29 7.222a1.926 1.926 0 0 0-1.927 1.927v5.143c0 1.064.863 1.927 1.927 1.927h.002a1.926 1.926 0 0 0 1.926-1.927V9.15a1.926 1.926 0 0 0-1.926-1.927zM11.363 9.15a4.926 4.926 0 0 1 4.927-4.927h.002a4.927 4.927 0 0 1 4.926 4.927v5.143a4.927 4.927 0 0 1-4.926 4.927h-.002a4.926 4.926 0 0 1-4.927-4.927zm-2.14 5.141v.05a7.02 7.02 0 0 0 7.019 7.018h.098a7.02 7.02 0 0 0 7.019-7.019v-.049h3v.05c0 5.04-3.724 9.212-8.57 9.914V28h-3v-3.746c-4.845-.704-8.566-4.875-8.566-9.915v-.049z",
    clipRule: "evenodd"
  })));
};
export default SvgMicrophone;